import { render, staticRenderFns } from "./QucikSupportCommandsView.vue?vue&type=template&id=2601d260&"
import script from "./QucikSupportCommandsView.vue?vue&type=script&lang=js&"
export * from "./QucikSupportCommandsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports